const GeneratedTagsCardStyles = {
  // Helper functions for dynamic styles
  getCardBorderColor: (date, value, colorPicker) => {
    const color = colorPicker(date, value);
    return color === 'success' ? '#52c41a' : color === 'error' ? '#ff4d4f' : '#d9d9d9';
  },
  
  getCardBackgroundColor: (date, value, colorPicker) => {
    const color = colorPicker(date, value);
    return color === 'success' ? '#f6ffed' : color === 'error' ? '#fff2f0' : '#fafafa';
  },
  
  getValueTextColor: (date, value, colorPicker) => {
    const color = colorPicker(date, value);
    return color === 'success' ? '#389e0d' : color === 'error' ? '#cf1322' : '#595959';
  },

  // Main card styles
  mainCard: {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
    border: "1px solid #f0f0f0",
    overflow: "hidden",
  },
  
  mainCardHead: {
    borderBottom: "1px solid #f0f0f0",
    fontSize: "16px",
    fontWeight: 600,
    color: "#262626",
  },

  // Metric card styles
  metricCard: {
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease",
  },
  
  metricCardBody: {
    padding: "16px",
    textAlign: "center"
  },
  
  metricSpace: {
    width: "100%"
  },
  
  metricLabel: {
    fontSize: "12px", 
    fontWeight: 500, 
    letterSpacing: "0.5px",
    textTransform: "uppercase"
  },
  
  metricValue: {
    fontSize: "24px", 
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block"
  },
  
  metricDate: {
    fontSize: "11px",
    fontWeight: 400,
    opacity: 0.7,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%"
  },
  
  basketItemsDate: {
    fontSize: "11px",
    fontWeight: 400,
    opacity: 0.7
  },

  // Results row styles
  resultsRow: {
    overflowX: "hidden"
  },
  
  delayNotice: {
    fontSize: "13px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block"
  },

  // Code section styles
  codeDivider: {
    margin: "24px 0 16px 0"
  },
  
  codeContainer: {
    width: "100%"
  },
  
  codeTitle: {
    fontSize: "13px", 
    letterSpacing: "0.5px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block"
  },
  
  codeCard: {
    overflowX: "auto",
    backgroundColor: "#1e1e1e",
    borderRadius: "12px",
    border: "1px solid #333",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    position: "relative",
  },
  
  codeCardBody: {
    padding: "0",
    fontFamily: "'Fira Code', 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', Consolas, monospace"
  },
  
  codeHeader: {
    backgroundColor: "#2d2d30",
    padding: "8px 16px",
    borderBottom: "1px solid #3e3e42",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  
  codeHeaderDots: {
    display: "flex", 
    gap: "6px"
  },
  
  codeHeaderDotRed: {
    width: "12px", 
    height: "12px", 
    borderRadius: "50%", 
    backgroundColor: "#ff5f57"
  },
  
  codeHeaderDotYellow: {
    width: "12px", 
    height: "12px", 
    borderRadius: "50%", 
    backgroundColor: "#ffbd2e"
  },
  
  codeHeaderDotGreen: {
    width: "12px", 
    height: "12px", 
    borderRadius: "50%", 
    backgroundColor: "#28ca42"
  },
  
  codeHeaderTitle: {
    color: "#cccccc", 
    fontSize: "12px", 
    marginLeft: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
    minWidth: 0
  },
  
  codeBlockTheme: {
    lineNumberColor: "#858585",
    lineNumberBgColor: "#252526",
    backgroundColor: "#1e1e1e",
    textColor: "#d4d4d4",
    substringColor: "#ce9178",
    keywordColor: "#569cd6",
    attributeColor: "#9cdcfe",
    selectorTagColor: "#f92672",
    docTagColor: "#6a9955",
    nameColor: "#dcdcaa",
    builtinColor: "#4ec9b0",
    literalColor: "#b5cea8",
    bulletColor: "#d7ba7d",
    codeColor: "#d4d4d4",
    additionColor: "#b5cea8",
    regexpColor: "#d16969",
    symbolColor: "#d4d4d4",
    variableColor: "#9cdcfe",
    templateVariableColor: "#9cdcfe",
    linkColor: "#569cd6",
    selectorAttributeColor: "#92c5f8",
    selectorPseudoColor: "#dcdcaa",
  },
  
  codeBlockCustom: {
    padding: "16px 0",
    margin: "0",
    backgroundColor: "#1e1e1e",
    fontSize: "14px",
    lineHeight: "1.6",
    fontFamily: "'Fira Code', 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', Consolas, monospace",
    borderRadius: "0 0 12px 12px",
  }
};

export default GeneratedTagsCardStyles;